import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class ChatService {
  fetchChatToken = (params) => {
    return fetch(config.config.endpointUrls.fetchChatToken(params), {
      method: 'POST',
      body: { ...params }
    })
  }
  deleteChatChannel = (params) => {
    return fetch(config.config.endpointUrls.deleteChatChannel(params), {
      method: 'DELETE',
      body: { ...params }
    })
  }
}

export default new ChatService()



// WEBPACK FOOTER //
// ../src/services/chatService/chatService.js